module.exports = __webpack_public_path__ + "img/search.620f8b62.svg";